<button class="btn btn-light map-btn" [ngClass]="{ active: active, specialSvg: specialSvg }" [disabled]="disabled"
        [trvTooltip]="toolTip"
        [attr.aria-label]="toolTip"
>
  <app-svg-icon [svgIcon]="svgIcon"></app-svg-icon>
  @if (notice) {
    <div class="notice">{{ noticeText }}</div>
  }
</button>
